<template>
	<div>
		<SwitchOption option-name="Prefill search term" :switch-model.sync="searchPrefillEnabled" />
		<div v-if="searchPrefillEnabled">
			<CombinedInputFieldDataMenu :value.sync="searchPrefillValue" :textAreaMode="false" :valuesTypes="dataInputMenuValueTypes" />
			<SwitchOption option-name="If one result is found, preselect it" :switch-model.sync="searchPrefillPreselectEnabled" />
		</div>
	</div>
</template>

<script>
import SwitchOption from '../FieldOptions/SwitchOption';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import ItemOnlyAllowedValueTypesMixin from '@/components/BlockEditorWidget/FieldSettings/ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
export default {
	name: 'PrefillSearchTermSettings',
	props: {
		localField: { type: Object },
	},
	mixins: [ItemOnlyAllowedValueTypesMixin],
	components: {
		SwitchOption,
		CombinedInputFieldDataMenu,
	},
	computed: {
		searchPrefillEnabled: {
			get() {
				return this.localField.metadata.options.searchPrefill.enabled;
			},
			set(value) {
				this.$emit('updateLocalField', { key: 'metadata.options.searchPrefill.enabled', value });
			},
		},
		searchPrefillValue: {
			get() {
				return this.localField.metadata.options.searchPrefill.value;
			},
			set(value) {
				this.$emit('updateLocalField', { key: 'metadata.options.searchPrefill.value', value });
			},
		},
		searchPrefillPreselectEnabled: {
			get() {
				return this.localField.metadata.options.searchPrefill.preselect.enabled;
			},
			set(value) {
				this.$emit('updateLocalField', { key: 'metadata.options.searchPrefill.preselect.enabled', value });
			},
		},
	},
};
</script>
<style scoped lang="scss"></style>
